<template>
  <div>
    <div v-if="showImageComponent" class="custom-upload">
      <div>
        <image-selector v-model="popupImage" />
        <p v-if="!popupImage" class="tip-error">请上传弹窗图片</p>
      </div>
      <p class="tip-upload">推荐使用300x375像素的.png图片</p>
    </div>
    <div v-if="showTextComponent" class="custom-text">
      <div>
        <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            :minlength="minlength"
            :maxlength="maxlength"
            :placeholder="'请输入文本内容，长度' + minlength + '-' + maxlength + ''"
            v-model="popupText">
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavSettingCustomPopupStyle',
  data() {
    return {
      minlength: 1,
      maxlength: 100,
      popupImage: '',
      popupText: ''
    }
  },
  watch: {
    popupImage: {
      deep: true,
      immediate: false,
      handler(newVal) {
        this.$$FormData.popup_image_data = newVal.src || ''
      }
    },
    popupText: {
      deep: true,
      immediate: false,
      handler(newVal) {
        this.$$FormData.popup_text_data = newVal || ''
      }
    }
  },
  computed: {
    /**
     * 是否显示组件
     * @returns {boolean}
     */
    showImageComponent() {
      return ['IMAGE'].includes(this.$$FormData.popup_style)
    },
    showTextComponent() {
      return ['TEXT'].includes(this.$$FormData.popup_style)
    }
  },
  mounted() {
    if (this.$$FormData.popup_style === 'IMAGE') {
      this.popupImage = {
        src: this.$$FormData.popup_image_data
      }
    }
    if (this.$$FormData.popup_style === 'TEXT') {
      this.popupText = this.$$FormData.popup_text_data
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-upload {
  display: flex;
  align-items: flex-end;
  margin-top: 12px;
  line-height: normal;
  .upload-box,
  .custom-img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    overflow: hidden;
    color: #155bd4;
    font-size: 20px;
    border: 1px solid #e5e5e5;
    background-color: #f2f4f6;
    cursor: pointer;
    .label-box {
      font-size: 12px;
      margin: 0;
      margin-top: 4px;
    }
  }
  .tip-error {
    margin-top: 5px;
    font-size: 12px;
    color: #d40000;
  }
  .tip-upload {
    color: #969799;
    margin-left: 10px;
    font-size: 12px;
  }
  .custom-img {
    position: relative;
    cursor: auto;
    .img-upload {
      width: 100%;
      height: 100%;
    }
    .change-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      color: #ffffff;
      background-color: rgba(0,0,0,.5);
      cursor: pointer;
    }
  }
}
</style>
